export default {
  'YouTube and High Definition Videos': 'Youtube и видео высокой четкости',
  'Story videos (Instagram/Snaps/TikTok)': 'Сюжетные видео (Instagram/Snaps)',
  'Facebook and Instagram Feed videos': 'Facebook and Instagram Feed видео',
  'Facebook and Twitter Portrait Videos': 'Портретные видео в Facebook и Twitter',
  'Twitter and Facebbok Landscape Videos': 'Twitter и FB Ландшафтные видео',
  'Facebook Cover Videos And Blog Banners': 'FB Обложка Видео И Баннеры Блога',
  'Fit': 'Подходить',
  'Fill': 'Заливать',
}